import { HOST_URL } from '@/const';

function getResourceUrl(resourceType: string, resourceId: string) {
  if (resourceType === 'Theme') return `${HOST_URL}/templates/template.html?resourceId=${resourceId}`;
  if (resourceType === 'Extension') return `${HOST_URL}/plugins/plugin.html?resourceId=${resourceId}`;
  if (resourceType === 'Service') return `${HOST_URL}/vip/#pricing`;
  return '#';
}

export default getResourceUrl;
